import React, { useEffect, useState } from 'react';
import { X, Menu } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
import { Link, useLocation } from 'react-router-dom';
const LOGO_WHITE = 'https://cdn.magicpatterns.com/uploads/jc63Wcs2z1JuqZfJSF71Nx/logo-white.png';
export function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const location = useLocation();
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  // Close mobile menu on route change
  useEffect(() => {
    setIsMobileMenuOpen(false);
  }, [location]);
  const navLinks = [{
    name: 'Home',
    href: '/'
  }, {
    name: 'Our Services',
    href: '/services'
  }, {
    name: 'About Us',
    href: '/#about'
  }, {
    name: 'Contact Us',
    href: '/#contact'
  }, {
    name: 'FAQ',
    href: '/#faq'
  }];
  const serviceLinks = [{
    name: 'Commercial Cleaning',
    href: '/book/commercial'
  }, {
    name: 'Basic Home Cleaning',
    href: '/book/home-cleaning'
  }, {
    name: 'Spring / Deep Cleaning',
    href: '/book/deep-cleaning'
  }, {
    name: 'Move-In / Move-Out',
    href: '/book/move-in-out'
  }, {
    name: 'Post Renovation',
    href: '/services'
  }, {
    name: 'Airbnb / Short Term Rental',
    href: '/services'
  }];
  return <>
      <header className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${isScrolled || location.pathname !== '/' ? 'bg-primary/95 backdrop-blur-md shadow-lg py-3' : 'bg-transparent py-5'}`} data-id="element-114">
        <div className="container mx-auto px-6 md:px-12 flex items-center justify-between" data-id="element-115">
          {/* Logo */}
          <Link to="/" className="z-[70] relative" data-id="element-116">
            <img src={LOGO_WHITE} alt="Smith & Jengs" className="h-14 md:h-16 lg:h-18" data-id="element-117" />
          </Link>

          {/* Desktop Nav */}
          <nav className="hidden md:flex items-center gap-8" data-id="element-118">
            {navLinks.map(link => {
            const isActive = link.href === '/' ? location.pathname === '/' : location.pathname.startsWith(link.href.replace('/#', '/'));
            return <Link key={link.name} to={link.href} className={`text-sm font-medium tracking-wide transition-colors uppercase ${isActive ? 'text-accent' : 'text-white/80 hover:text-white'}`} data-id="element-119">
                  {link.name}
                </Link>;
          })}
            <Link to="/book/commercial" className="bg-accent hover:bg-accent/90 text-white px-6 py-2.5 rounded-full text-sm font-bold uppercase tracking-wider transition-all transform hover:scale-105 inline-block text-center" data-id="element-120">
              Book Now
            </Link>
          </nav>

          {/* Mobile Menu Toggle */}
          <button className="md:hidden z-[70] relative" onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)} aria-label={isMobileMenuOpen ? 'Close menu' : 'Open menu'} data-id="element-121">
            {isMobileMenuOpen ? <X size={28} className="text-white" data-id="element-122" /> : <Menu size={32} className="text-accent" data-id="element-123" />}
          </button>
        </div>
      </header>

      {/* Mobile Menu Drawer - Outside header to avoid stacking context issues */}
      <AnimatePresence data-id="element-124">
        {isMobileMenuOpen && <motion.div initial={{
        opacity: 0,
        x: '100%'
      }} animate={{
        opacity: 1,
        x: 0
      }} exit={{
        opacity: 0,
        x: '100%'
      }} transition={{
        type: 'spring',
        damping: 25,
        stiffness: 200
      }} className="fixed inset-0 bg-primary z-[60] flex flex-col items-center gap-4 overflow-y-auto pt-28 pb-12 px-6" data-id="element-125">
            {/* Book Now - Prominent at top */}
            <Link to="/book/commercial" className="bg-accent text-white px-10 py-4 rounded-full text-xl font-bold uppercase tracking-wider inline-block text-center shadow-lg shadow-accent/30 hover:bg-accent/90 transition-all w-full max-w-xs" data-id="element-126">
              Book Now
            </Link>

            <div className="w-24 h-px bg-white/20 my-2" data-id="element-127" />

            {navLinks.map(link => <Link key={link.name} to={link.href} className="text-white text-2xl font-heading uppercase tracking-widest hover:text-accent transition-colors" data-id="element-128">
                {link.name}
              </Link>)}

            {/* Services Section */}
            <div className="w-full flex flex-col items-center mt-2" data-id="element-129">
              <div className="w-24 h-px bg-white/20 mb-4" data-id="element-130" />
              <span className="text-accent text-sm font-bold uppercase tracking-[0.2em] mb-3" data-id="element-131">
                Services
              </span>
              {serviceLinks.map(link => <Link key={link.name} to={link.href} className="text-white/70 text-base font-medium tracking-wide hover:text-accent transition-colors py-1.5" data-id="element-132">
                  {link.name}
                </Link>)}
            </div>
          </motion.div>}
      </AnimatePresence>
    </>;
}